import React, { memo } from "react";
import { Box, Card, CardContent, Stack, Typography } from "@mui/material";

export interface PageHeroProps {
  title: string;
  subtitle: React.ReactNode;
  icon?: React.ReactNode;
  fromColor?: string;
  toColor?: string;
}

const PageHero: React.FC<PageHeroProps> = memo(
  ({ title, subtitle, icon, fromColor, toColor }) => {
    return (
      <Card
        sx={{
          background: (theme) => {
            const from = fromColor || theme.palette.primary.main;
            const to = toColor || theme.palette.secondary.main;
            return `linear-gradient(135deg, ${from} 0%, ${to} 100%)`;
          },
          color: "primary.contrastText",
        }}
      >
        <CardContent>
          <Stack
            direction={{ xs: "column", md: "row" }}
            spacing={3}
            alignItems="center"
            justifyContent="space-between"
          >
            <Stack spacing={1}>
              <Typography variant="h5" fontWeight={700}>
                {title}
              </Typography>
              <Typography variant="subtitle2" sx={{ opacity: 0.9 }}>
                {subtitle}
              </Typography>
            </Stack>
            {icon && (
              <Box
                sx={{
                  width: 64,
                  height: 64,
                  borderRadius: "50%",
                  border: "2px solid rgba(255, 255, 255, 0.6)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "2rem",
                }}
              >
                {icon}
              </Box>
            )}
          </Stack>
        </CardContent>
      </Card>
    );
  },
);

PageHero.displayName = "PageHero";

export default PageHero;
